(function(){
  'use strict';
  var KEY = 'bv_wishlist_v1';
  function getList(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; }
  }
  function setList(arr){
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){}
    paint();
  }
  function paint(){
    var list = getList();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var h = btn.getAttribute('data-handle');
      var on = list.indexOf(h) !== -1;
      btn.classList.toggle('text-tertiary', on);
      btn.classList.toggle('bg-tertiary/10', on);
      var icon = btn.querySelector('.material-symbols-outlined');
      if (icon) icon.classList.toggle('filled', on);
      btn.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    // Update header counter (if present)
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = list.length;
      el.classList.toggle('hidden', list.length === 0);
      el.classList.toggle('flex', list.length > 0);
    });
  }
  function showToast(added){
    var toast = document.getElementById('bv-wish-toast');
    if (!toast) return;
    toast.innerHTML = (added ? '❤️ Favorilere eklendi' : '🤍 Favorilerden çıkarıldı')
      + ' <a href="/pages/favorilerim">Görüntüle</a>';
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove('show'); }, 3000);
  }

  function toggle(handle){
    var list = getList();
    var i = list.indexOf(handle);
    var added;
    if (i === -1){ list.unshift(handle); added = true; }
    else { list.splice(i, 1); added = false; }
    setList(list);
    showToast(added);
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
  });
  document.addEventListener('DOMContentLoaded', paint);
  window.CeptEczaWishlist = { get: getList, toggle: toggle };
})();
